import type { NombreIcono } from '../Icono';

export interface ItemMenu {
  texto: string;
  icono: NombreIcono;
  ruta: string;
  /** Otras rutas en las que el ítem se marca como activo (el detalle de un turno, por ejemplo). */
  tambien?: readonly string[];
  insignia?: number;
}

export type EntradaMenu = ItemMenu | 'separador';

export const MENU_PROFESIONAL: readonly EntradaMenu[] = [
  { texto: 'Agenda', icono: 'calendar-days', ruta: '/pro/agenda' },
  { texto: 'Turnos', icono: 'list-checks', ruta: '/pro/turnos', tambien: ['/pro/turno/'] },
  { texto: 'Pacientes', icono: 'users', ruta: '/pro/pacientes', tambien: ['/pro/paciente/'] },
  { texto: 'Métricas', icono: 'bar-chart-3', ruta: '/pro/metricas' },
  'separador',
  { texto: 'Perfil', icono: 'user-cog', ruta: '/pro/perfil' },
  { texto: 'Servicios y horarios', icono: 'list-checks', ruta: '/pro/servicios' },
  { texto: 'Recordatorios', icono: 'message-circle', ruta: '/pro/whatsapp' },
  { texto: 'Cuenta y plan', icono: 'credit-card', ruta: '/pro/cuenta' },
];

export const MENU_ADMINISTRACION: readonly EntradaMenu[] = [
  { texto: 'Panel general', icono: 'layout-dashboard', ruta: '/admin' },
  { texto: 'Profesionales', icono: 'stethoscope', ruta: '/admin/profesionales', tambien: ['/admin/profesional/'] },
  { texto: 'Reclamos', icono: 'flag', ruta: '/admin/reclamos', tambien: ['/admin/reclamo/'] },
  { texto: 'Reseñas', icono: 'star', ruta: '/admin/resenas' },
];
